// See tailwind-workspace-preset.js for eViolin colour codes.
export enum EViolinStatus {
  ACTIVE = 'Active',
  AVAILABLE = 'Available',
  CHARGING = 'Charging',
  ERROR = 'Error',
  FULLY_CHARGED = 'FullyCharged',
  INACTIVE = 'Inactive'
}
